import { FC, useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormFields } from '../../types';
import { isFormSectionTitleConfig, schemaToFormConfig } from '../../utils';

import FormFieldRenderer from '../FormFieldRenderer';
import FormSectionTitleRenderer from '../FormSectionTitleRenderer';

import { Props } from './types';

const SchemaRenderer: FC<Props> = ({ schema, skipPropNames }) => {
  const { reset } = useFormContext<FormFields>();

  const memoFormConfig = useMemo(
    () => schemaToFormConfig(schema, skipPropNames),
    [schema, skipPropNames],
  );

  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <>
      {memoFormConfig.map((fieldConfig) => {
        if (isFormSectionTitleConfig(fieldConfig)) {
          return (
            <FormSectionTitleRenderer
              key={fieldConfig.name}
              name={fieldConfig.name}
              type={fieldConfig.sectionTitleType}
            />
          );
        }

        return <FormFieldRenderer key={fieldConfig.name} field={fieldConfig} />;
      })}
    </>
  );
};

export default SchemaRenderer;
